import { render, staticRenderFns } from "./taxAnnualWagesList.vue?vue&type=template&id=b197f4aa&scoped=true&"
import script from "./taxAnnualWagesList.vue?vue&type=script&lang=js&"
export * from "./taxAnnualWagesList.vue?vue&type=script&lang=js&"
import style0 from "./taxAnnualWagesList.vue?vue&type=style&index=0&id=b197f4aa&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b197f4aa",
  null
  
)

export default component.exports